const lang = {
    "Kep": "QES",
    "KepNotLinked": "sua assinatura qualificada ainda não está vinculada a uma conta. Entre como de costume e nós a vincularemos.",
    "KepNewAccount": "Não tem conta? Cadastre-se",
    "KepLinked": "Assinatura qualificada vinculada à conta",
    "KepLinkFailed": "Não foi possível vincular a assinatura qualificada. Entre com ela novamente e nós a vincularemos",
    "KepFile": "Arquivo de chave",
    "ErrorKepLogin": "Não foi possível entrar com a assinatura qualificada",
    "EnterWidth": "Entrar com:",
    "Registration": "Registro",
    "enter": "Entrar",
    "EntrWidthEmailOrPhone": "Faça login com e-mail ou telefone",
    "login": "Autorização",
    "NoAkkGoReg": "Registrar",
    "Password": "Senha",
    "Name": "Nome",
    "LastName": "Sobrenome",
    "Phone": "Para se registrar, digite seu número de telefone",
    "Email": "Correspondência",
    "RepeatPassword": "Repita a senha",
    "Сancel": "Cancelar",
    "Save": "Salve ",
    "Language": "Linguagem",
    "ConfirmThisMail": "Seu email foi confirmado",
    "Saved": "Salvou",
    "Error": "Erro",
    "FillInAllTheFields": "Preencha todos os campos",
    "Next": "Mais distante",
    "MinPassLength": "Comprimento mínimo da senha 4 caracteres",
    "ForgotYourPassword": "Esqueceu sua senha",
    "RestorePassword": "Por favor, defina uma nova senha.",
    "UserMustBeRegistered": "O usuário deve estar cadastrado",
    "Confirm": "confirme",
    "WrongFormat": "Formato incorreto",
    "WrongPassword": "Senha incorreta",
    "WrongLoginOrPassword": "login ou senha errada",
    "PhoneAlreadyRegistered": "Telefone já cadastrado",
    "EmailAlreadyRegistered": "Correio já cadastrado",
    "FillInTheFieldsCorrectly": "Preencha corretamente os campos",
    "ThisAccountDoesNotExist": "Essa conta não existe",
    "LinkIsNotValid": "O link não é válido",
    "AMessageHasBeenSentToTheSpecifiedLogin": "Uma mensagem foi enviada para o nome de usuário especificado",
    "IncorrectCaptcha": "CAPTCHA errado",
    "CaptchaIsNotValid": "Captcha não é mais válido",
    "EnterCaptcha": "Digite captcha",
    "EnterSMS": "Digite o código do SMS",
    "SMSCodeIsNoLongerValid": "O código SMS não é mais válido",
    "SMSCodeIsIncorrect": "O código SMS está incorreto",
    "MailNotVerifiedLinkTimedOut": "E-mail não confirmado, link expirado",
    "DemoLogin": "Login de demonstração",
    "AreYouSureYouWantToEnterTheDemoForEvaluation": "Tem certeza de que deseja entrar na <b> demonstração </b> para experimentá-la?",
    "FillInAdditionalInformation": "Preencha as informações adicionais",
    "ToCompleteRegistration": "Para concluir o cadastro",
    "LinkThirdPartyServices": "Vincular serviços de terceiros",
    "Complete": "Completar",
    "AccountAlreadyLinked": "Conta já vinculada",
    "AccountNotRegistered": "Conta não cadastrada",
    "NotMyNumber": "Não é meu número",
    "Back": "Costas",
    "numberOfAttemptsToCheckAuth": "Número de tentativas de login:",
    "InvalidPassNumberOfAttemptsToCheckAuth": "Senha incorreta, número de tentativas de login:",
    "TryAgainAfterMinute": "Por favor, tente novamente em 2 minutos",
    "Help": "Apoio, suporte",
    "y": "Sim",
    "n": "Não",
    "doYouConfirmEmail": "Tem certeza de que deseja alterar seu e-mail?",
    "success": "com sucesso",
    "goToAutorize": "Ir para autorização",
    "UserEmailAlreadyExists": "Já existe usuário com este endereço de email",
    "UserPhoneAlreadyExists": "Já existe um usuário com este número de telefone",
    "TermOfUse": "Termos de uso",
    "PrivacyPolicy": "Política de Privacidade",
    "accountNotRegistered": "conta não cadastrada",
    "wantToReg": "Voce gostaria de se registrar?",
    "weSuccessChangeYouEmail": "Alteramos seu endereço de e-mail com sucesso",
    "youCanCloseThisWindow": "Você pode fechar esta janela",
    "countryConfirm": "Confirmação do país",
    "EmailAlreadyTied": "O e-mail já está vinculado a outra conta",
    "areYourCountry": "este é o seu país?",
    "EmergencyEntrance": "Autorização antiga",
    "enterCorrectNumber": "Digite o número no formato internacional",
    "thisPhoneRegister": "Este número de telefone já está cadastrado no sistema",
    "wantUsePhoneForAuth": "Deseja fazer login usando este número de telefone?",
    "ok": "ok",
    "regAgree": "Ao registrar uma conta, eu aceito",
    "wantBind": "Deseja entrar e vincular o serviço",
    "bind": "ligar",
    "yoursMailBinded": "Seu e-mail está em uma conta existente",
    "wantUsePhoneAndBind": "já cadastrado no sistema",
    "notGetDataFromApple": "Falha ao receber dados da Apple",
    "ErrorAppleLogin": "Erro ao autorizar via Apple",
    "ErrorGoogleLogin": "Erro ao autorizar via Google",
    "ErrorTelegramLogin": "Erro ao efetuar login via Telegram",
    "ErrorFacebookLogin": "Erro ao fazer login via Facebook",
    "EMailOrPhone": "Insira um número de telefone ou endereço de e-mail válido.",
    "withoutName": "Sem nome",
    "goToCabinet": "Para o escritório",
    "Logout": "Fim da sessão",
    "creationDate": "Data de criação",
    "preparingCompany1": "Estamos criando sua empresa, por favor, nos dê um minuto...",
    "preparingCompany2": "Estamos preparando uma interface para gerenciamento de bens e serviços...",
    "preparingCompany3": "Estamos trabalhando em uma contabilidade financeira conveniente...",
    "preparingCompany4": "Estamos fazendo as configurações finais, quase pronto...",
    "companyBlocked": "Esta empresa está inativa",
    "youBlockedInComp": "O usuário não está ativo, o login não é possível",
    "loginTitle": "Tudo o que uma empresa precisa em um só lugar",
    "loginDescr": "Automação para lojas, cafés, serviços de entrega, restaurantes, armazéns, produção ou serviços",
    "NoAkkGoRegText": "Não tem uma conta?",
    "LoginPlaceholder": "Por favor, forneça as informações necessárias",
    "loginText": "Já tem uma conta?",
    "and": "E",
    "AcceptTheTerms": "Por favor, aceite a política de privacidade e os termos de uso",
    "CountryPhoneFormat": "Se este não for seu país, verifique se você digitou seu número de telefone no formato internacional correto.",
    "SaveNewPassword": "Salvar nova senha"
}

export default function() {
    return lang;
}